/* =================================================================
   VALORA theme — interactions + Shopify AJAX cart
   ================================================================= */
(function () {
  "use strict";

  var V = window.VALORA || { routes: { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart: "/cart" }, bundleMinQty: 3 };
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var d = (cents || 0) / 100;
    var frac = d % 1 === 0 ? 0 : 2;
    return "$" + d.toLocaleString("en-US", { minimumFractionDigits: frac, maximumFractionDigits: 2 });
  }

  /* ---------- reveal ---------- */
  var revealEls = $$("[data-reveal], [data-reveal-lines]");
  if ("IntersectionObserver" in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else { revealEls.forEach(function (el) { el.classList.add("is-in"); }); }

  /* ---------- park offscreen animation ----------
     An infinite CSS animation keeps the compositor producing frames for as
     long as the page is open, whether or not the element is anywhere near the
     viewport. The photo rails are wide composited layers, so that cost is real
     on a phone. Park them until they're on screen — the loop is seamless, so
     nobody can tell it was ever stopped. Deliberately not parked up front: if
     the observer never fires, the rails keep moving. A frozen rail is a visible
     bug; a few frames of animation before the first callback is not. */
  (function () {
    var tracks = $$(".marquee__track, .announce__track");
    if (!tracks.length || !("IntersectionObserver" in window)) return;
    var mo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.removeAttribute("data-mq-idle");
        else e.target.setAttribute("data-mq-idle", "");
      });
    }, { rootMargin: "150px 0px" });
    tracks.forEach(function (t) { mo.observe(t); });
  })();

  /* ---------- header scrolled ---------- */
  var header = $("[data-header]");
  function onScrollHeader() { if (header) header.toggleAttribute("data-scrolled", window.scrollY > 8); }
  onScrollHeader();
  window.addEventListener("scroll", onScrollHeader, { passive: true });

  /* ---------- smooth scroll (works across pages via /#id) ---------- */
  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.scrollY - 64;
    window.scrollTo({ top: top, behavior: reduceMotion ? "auto" : "smooth" });
    return true;
  }
  $$("[data-scroll]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      var href = a.getAttribute("href") || a.getAttribute("data-scroll-href") || "";
      var hashIndex = href.indexOf("#");
      if (hashIndex === -1) return;
      var id = href.slice(hashIndex + 1);
      if (document.getElementById(id)) { e.preventDefault(); scrollToId(id); closeMobileNav(); }
      // else: let the browser navigate (e.g. /#science from another page)
    });
  });
  var heroScroll = $(".hero__scroll");
  if (heroScroll) heroScroll.addEventListener("click", function () { scrollToId((heroScroll.getAttribute("data-scroll-href") || "").replace("#", "")); });

  /* ---------- mobile nav ---------- */
  var navToggle = $("[data-nav-toggle]"), mobileNav = $("[data-mobile-nav]");
  function closeMobileNav() { if (mobileNav) { mobileNav.hidden = true; if (navToggle) navToggle.setAttribute("aria-expanded", "false"); } }
  if (navToggle && mobileNav) {
    navToggle.addEventListener("click", function () {
      var open = navToggle.getAttribute("aria-expanded") === "true";
      navToggle.setAttribute("aria-expanded", String(!open));
      mobileNav.hidden = open;
    });
  }

  /* ---------- hero aura ---------- */
  var auraScope = $("[data-aura-scope]"), aura = $("[data-aura]");
  if (auraScope && aura && !reduceMotion) {
    auraScope.addEventListener("pointermove", function (e) {
      var r = auraScope.getBoundingClientRect();
      aura.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
      aura.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
    });
  }

  /* ---------- parallax ---------- */
  var parallaxEls = $$("[data-parallax]");
  if (parallaxEls.length && !reduceMotion) {
    var ticking = false;
    function runParallax() {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var depth = parseFloat(el.getAttribute("data-depth")) || 0.18;
        var offset = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = "translate3d(0," + (offset * depth * -60).toFixed(2) + "px,0)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(runParallax); } }, { passive: true });
    runParallax();
  }

  /* ---------- NAD+ lifeline ---------- */
  (function () {
    var fig = $("[data-lifeline]");
    if (!fig) return;
    var W = 800, H = 380, PAD_T = 24, PAD_B = 44, PAD_X = 10, AGE_MIN = 30, AGE_MAX = 65;
    var curve = $("[data-ll-curve]", fig), area = $("[data-ll-area]", fig), grid = $("[data-ll-grid]", fig);
    var guide = $("[data-ll-guide]", fig), dot = $("[data-ll-dot]", fig), range = $("[data-ll-range]", fig);
    var ageOut = $("[data-ll-age]", fig), nadOut = $("[data-ll-nad]", fig), capOut = $("[data-ll-caption]", fig), plot = $(".lifeline__plot", fig);

    function nadAt(age) { var t = (age - AGE_MIN) / (AGE_MAX - AGE_MIN); return 90 - 55 * Math.pow(t, 1.4); }
    function ageToX(age) { return PAD_X + (age - AGE_MIN) / (AGE_MAX - AGE_MIN) * (W - PAD_X * 2); }
    function nadToY(v) { return PAD_T + (90 - v) / (90 - 35) * (H - PAD_T - PAD_B); }
    function buildPath(close) {
      var pts = [], age;
      for (age = AGE_MIN; age <= AGE_MAX; age++) pts.push([ageToX(age), nadToY(nadAt(age))]);
      var d = "M" + pts[0][0] + "," + pts[0][1];
      for (var i = 0; i < pts.length - 1; i++) {
        var x0 = pts[i][0], y0 = pts[i][1], x1 = pts[i + 1][0], y1 = pts[i + 1][1];
        d += " Q" + x0 + "," + y0 + " " + ((x0 + x1) / 2) + "," + ((y0 + y1) / 2);
      }
      d += " L" + pts[pts.length - 1][0] + "," + pts[pts.length - 1][1];
      if (close) d += " L" + pts[pts.length - 1][0] + "," + (H - PAD_B) + " L" + pts[0][0] + "," + (H - PAD_B) + " Z";
      return d;
    }
    curve.setAttribute("d", buildPath(false));
    area.setAttribute("d", buildPath(true));
    [90, 75, 60, 45, 35].forEach(function (v) {
      var y = nadToY(v), ln = document.createElementNS("http://www.w3.org/2000/svg", "line");
      ln.setAttribute("x1", PAD_X); ln.setAttribute("x2", W - PAD_X); ln.setAttribute("y1", y); ln.setAttribute("y2", y);
      grid.appendChild(ln);
    });
    function captionFor(age) {
      if (age <= 41) return "Early perimenopause can begin here. NAD⁺ in key tissues is already trending down.";
      if (age <= 50) return "The decline tends to steepen. This is the window where “I don’t feel like myself” shows up most.";
      if (age <= 58) return "Into menopause. Supporting healthy NAD⁺ levels matters most through this stretch.";
      return "Post-menopause. Consistency is everything — a molecule you keep topped up, daily.";
    }
    function render(age) {
      age = Math.round(age);
      var v = nadAt(age), x = ageToX(age), y = nadToY(v);
      dot.style.left = (x / W * 100) + "%"; dot.style.top = (y / H * 100) + "%";
      guide.setAttribute("x1", x); guide.setAttribute("x2", x); guide.setAttribute("y1", y); guide.setAttribute("y2", H - PAD_B);
      ageOut.textContent = age; nadOut.textContent = "~" + Math.round(v); capOut.textContent = captionFor(age);
    }
    range.addEventListener("input", function () { render(+range.value); });
    function setFromX(clientX) {
      var r = plot.getBoundingClientRect(), ratio = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      range.value = Math.round(AGE_MIN + ratio * (AGE_MAX - AGE_MIN)); render(+range.value);
    }
    var dragging = false;
    plot.addEventListener("pointerdown", function (e) { dragging = true; setFromX(e.clientX); });
    window.addEventListener("pointermove", function (e) { if (dragging) setFromX(e.clientX); });
    window.addEventListener("pointerup", function () { dragging = false; });
    function draw() {
      if (!reduceMotion) { try { var len = curve.getTotalLength(); curve.style.strokeDasharray = len; curve.style.strokeDashoffset = len; curve.getBoundingClientRect(); curve.style.transition = "stroke-dashoffset 1.5s cubic-bezier(.16,1,.3,1)"; curve.style.strokeDashoffset = "0"; } catch (e) {} }
      render(+range.value);
    }
    if ("IntersectionObserver" in window) {
      var io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { draw(); io2.unobserve(e.target); } }); }, { threshold: 0.3 });
      io2.observe(fig);
    } else { draw(); }
  })();

  /* ---------- count-up ---------- */
  (function () {
    var stats = $$("[data-count]");
    if (!stats.length) return;
    function up(el) {
      var target = parseFloat(el.getAttribute("data-count")), suffix = el.getAttribute("data-suffix") || "";
      var dec = (String(target).split(".")[1] || "").length;
      if (reduceMotion) { el.textContent = target.toFixed(dec) + suffix; return; }
      var start = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - start) / 1400), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(dec) + suffix;
        if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec) + suffix;
      })(start);
    }
    if ("IntersectionObserver" in window) {
      var io3 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { up(e.target); io3.unobserve(e.target); } }); }, { threshold: 0.6 });
      stats.forEach(function (el) { io3.observe(el); });
    } else { stats.forEach(up); }
  })();

  /* ---------- FAQ accordion ---------- */
  $$(".faq-item__body").forEach(function (b) { b.style.transition = "height .35s cubic-bezier(.22,.61,.36,1)"; });
  $$(".faq-item").forEach(function (item) {
    var summary = $("summary", item), body = $(".faq-item__body", item);
    summary.addEventListener("click", function (e) {
      e.preventDefault();
      if (item.open) {
        body.style.height = body.scrollHeight + "px";
        requestAnimationFrame(function () { body.style.height = "0px"; });
        body.addEventListener("transitionend", function te() { item.open = false; body.style.height = ""; body.removeEventListener("transitionend", te); });
      } else {
        item.open = true; var h = body.scrollHeight; body.style.height = "0px";
        requestAnimationFrame(function () { body.style.height = h + "px"; });
        body.addEventListener("transitionend", function te() { body.style.height = ""; body.removeEventListener("transitionend", te); });
      }
    });
  });

  /* =================================================================
     SHOPIFY AJAX CART
     ================================================================= */
  var cart = $("[data-cart]"), itemsEl = $("[data-cart-items]"), giftsEl = $("[data-cart-gifts]");
  var upsellEl = $("[data-cart-upsell]"), countEl = $("[data-cart-count]"), headingEl = $("[data-cart-heading]");
  var totalEl = $("[data-cart-total]"), toast = $("[data-toast]");
  var progEl = $("[data-cart-progress]"), progFill = $("[data-cart-progress-fill]"), progMsg = $("[data-cart-progress-msg]");

  var BUNDLE_QTY = (V && V.bundleMinQty) || 3;
  var GIFTS = (V && V.gifts) || [{ name: "$30 store gift card", was: 3000, icon: "card" }, { name: "Longevity Reset Guide (PDF)", was: 1900, icon: "book" }];
  var UPSELL = (V && V.upsell) || { name: "The 90-Day Reset", note: "Save $42 + 2 free gifts", price: 15900, image: "" };
  var ROUTES = (V && V.routes) || { add: "/cart/add.js", change: "/cart/change.js", cart: "/cart.js" };
  var currentCart = { item_count: 0, items: [] };

  // Gift-with-purchase: the 90-Day Reset adds 3 NMN + 1 Magnesium + 1 Moisturizer as real
  // line items so they actually ship; automatic discounts zero the two gifts + take $33 off the
  // bottles (→ $168). The gifts are hidden from the editable item list and shown as perk rows.
  var nmnId = (V && V.nmnVariantId) || 0;
  var giftIds = (V && V.giftVariantIds) || [];
  function isGift(it) { return giftIds.indexOf(it.variant_id) !== -1 || giftIds.indexOf(it.id) !== -1; }
  function lineOf(c, vid) { return (c.items || []).filter(function (it) { return it.variant_id === vid || it.id === vid; })[0]; }
  function mainItemsOf(c) { return (c.items || []).filter(function (it) { return !isGift(it); }); }
  function mainQtyOf(c) { return mainItemsOf(c).reduce(function (s, it) { return s + it.quantity; }, 0); }

  function fmt(c) { return "$" + ((c || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function giftIcon(t) {
    if (t === "ship") return '<svg viewBox="0 0 24 24" fill="none"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.8" stroke="currentColor" stroke-width="1.4"/><circle cx="17" cy="17" r="1.8" stroke="currentColor" stroke-width="1.4"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none"><rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" stroke-width="1.4"/><path d="M3 11h18M8 7c-1.5-3 3-4 4-1 1-3 5.5-2 4 1" stroke="currentColor" stroke-width="1.4"/></svg>';
  }
  function thumb(url) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : ""; }
  function supplyLabel(q) { return q >= BUNDLE_QTY ? "90-Day Reset · " + q + " bottles" : (q === 1 ? "Single bottle" : q + "-bottle supply"); }

  // The $33 bundle saving is an ORDER-scope automatic discount, so Shopify never
  // folds it into the NMN line price — it only lands on the cart total. Pull it out
  // so the line can show "$168.00  $201.00" the same way the gift rows do.
  function orderLevelDiscount(c) {
    var apps = c.cart_level_discount_applications || [];
    if (apps.length) {
      return apps.reduce(function (a, d) { return a + (d.total_allocated_amount || 0); }, 0);
    }
    var lineDisc = (c.items || []).reduce(function (a, it) {
      return a + ((it.original_line_price || 0) - (it.final_line_price || 0));
    }, 0);
    return Math.max(0, (c.total_discount || 0) - lineDisc);
  }

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.hidden = false;
    requestAnimationFrame(function () { toast.setAttribute("data-show", ""); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.removeAttribute("data-show"); setTimeout(function () { toast.hidden = true; }, 320); }, 2400);
  }
  function openCart() { if (cart) { cart.hidden = false; requestAnimationFrame(function () { cart.setAttribute("data-open", ""); }); } }
  function closeCart() { if (cart) { cart.removeAttribute("data-open"); setTimeout(function () { cart.hidden = true; }, 400); } }

  function render(c) {
    currentCart = c;
    var mainItems = mainItemsOf(c);            // bottles only (gifts hidden from the list)
    var count = mainQtyOf(c);                  // display count = bottles
    var bundle = count >= BUNDLE_QTY;

    if (headingEl) headingEl.textContent = "Cart (" + count + ")";
    if (countEl) { countEl.textContent = count; countEl.hidden = count === 0; }
    if (totalEl) {
      // original_total_price = every item at full price, i.e. buying them separately
      var origTotal = c.original_total_price || c.total_price;
      totalEl.innerHTML = origTotal > c.total_price
        ? '<s>' + fmt(origTotal) + '</s> ' + fmt(c.total_price)
        : fmt(c.total_price);
    }

    if (progEl) {
      progEl.hidden = count === 0;
      if (progFill) progFill.style.width = (Math.min(count / BUNDLE_QTY, 1) * 100) + "%";
      if (progMsg) progMsg.textContent = bundle
        ? "You've unlocked free shipping + free gifts"
        : "Add " + (BUNDLE_QTY - count) + " more " + (BUNDLE_QTY - count === 1 ? "bottle" : "bottles") + " for free shipping + gifts";
    }

    if (itemsEl) {
      var orderDisc = orderLevelDiscount(c);
      if (!count) itemsEl.innerHTML = '<p class="cart__empty">Your cart is empty.</p>';
      else itemsEl.innerHTML = mainItems.map(function (it, idx) {
        // the cart-scope bundle saving belongs to the bottles line
        var lineNow = it.final_line_price - (idx === 0 ? orderDisc : 0);
        var lineWas = it.original_line_price;
        var disc = lineWas > lineNow;
        var img = it.image ? '<img src="' + thumb(it.image) + '" alt="" loading="lazy">' : "";
        return '<div class="cart-line" data-key="' + it.key + '">' +
          '<div class="cart-line__media">' + img + '</div>' +
          '<div class="cart-line__main">' +
            '<div class="cart-line__top"><span class="cart-line__name">' + it.product_title + '</span>' +
            '<span class="cart-line__price">' + fmt(lineNow) + (disc ? ' <s>' + fmt(lineWas) + '</s>' : '') + '</span></div>' +
            '<div class="cart-line__supply">' + supplyLabel(it.quantity) + '</div>' +
            '<div class="cart-line__onetime">One-time purchase · ships once</div>' +
            '<div class="cart-line__controls"><div class="cart-qty">' +
              '<button type="button" data-dec aria-label="Decrease">−</button><span class="mono">' + it.quantity + '</span><button type="button" data-inc aria-label="Increase">+</button>' +
            '</div><button type="button" class="cart-line__remove" data-remove>Remove</button></div>' +
          '</div></div>';
      }).join("");
    }

    if (giftsEl) {
      giftsEl.hidden = !bundle;
      giftsEl.innerHTML = !bundle ? "" :
        '<p class="cart-gifts__title">Your 90-Day Reset — free with your bottles</p>' +
        '<p class="cart-gifts__sub">NMN resets you from the inside. Your gummies and serum work on hair, skin and nails from the outside.</p>' +
        GIFTS.map(function (g) {
          var media = g.image ? '<img src="' + g.image + '" alt="">' : giftIcon(g.icon);
          var price = g.was > 0 ? '$0.00 <s>' + fmt(g.was) + '</s>' : 'Free';
          return '<div class="cart-gift"><div class="cart-gift__media">' + media + '</div>' +
            '<div class="cart-gift__main"><div class="cart-gift__top"><span class="cart-gift__name">' + g.name + '</span>' +
            '<span class="cart-gift__price">' + price + '</span></div>' +
            '<div class="cart-gift__label">Free gift</div><div class="cart-gift__note">' + g.note + '</div></div></div>';
        }).join("");
    }

    if (upsellEl) {
      var showUp = count > 0 && !bundle;
      upsellEl.hidden = !showUp;
      upsellEl.innerHTML = !showUp ? "" :
        '<p class="cart__upsell-title">Complete your routine</p>' +
        '<div class="upsell-card"><div class="upsell-card__media">' + (UPSELL.image ? '<img src="' + UPSELL.image + '" alt="">' : '') + '</div>' +
        '<div><div class="upsell-card__name">' + UPSELL.name + '</div><div class="upsell-card__price">' + fmt(UPSELL.price) + ' · ' + UPSELL.note + '</div></div>' +
        '<button type="button" class="upsell-card__add" data-upsell aria-label="Add the 90-Day Reset">+</button></div>';
    }
  }

  function getCart() { return fetch(ROUTES.cart, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function postJSON(url, body) { return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }

  // Keep the free gifts in sync with the bundle: present (qty 1 each) when there are >=3 bottles,
  // removed otherwise — so a customer is never charged for a gift.
  function syncGifts(c) {
    if (!giftIds.length) return Promise.resolve(c);
    if (mainQtyOf(c) >= BUNDLE_QTY) {
      var toAdd = giftIds.filter(function (gid) { return !lineOf(c, gid); }).map(function (gid) { return { id: Number(gid), quantity: 1 }; });
      if (!toAdd.length) return Promise.resolve(c);
      return postJSON(ROUTES.add, { items: toAdd }).then(getCart);
    }
    var present = (c.items || []).filter(isGift);
    if (!present.length) return Promise.resolve(c);
    return present.reduce(function (p, gl) { return p.then(function () { return postJSON(ROUTES.change, { id: gl.key, quantity: 0 }); }); }, Promise.resolve()).then(getCart);
  }
  function refresh() { return getCart().then(syncGifts).then(render); }

  function addToCart(variantId, qty) { return postJSON(ROUTES.add, { items: [{ id: Number(variantId), quantity: qty }] }).then(refresh); }
  // The 90-Day Reset: ensure at least `qty` bottles are in the cart, then syncGifts adds the 2 free gifts.
  function addBundle(variantId, qty) {
    return getCart().then(function (c) {
      var cur = lineOf(c, Number(variantId)); cur = cur ? cur.quantity : 0;
      if (cur >= qty) return refresh();
      return postJSON(ROUTES.add, { items: [{ id: Number(variantId), quantity: qty - cur }] }).then(refresh);
    });
  }
  function changeQty(key, qty) { return postJSON(ROUTES.change, { id: key, quantity: qty }).then(refresh); }

  // Shared with valora-pdp.js so the express-wallet buttons add an offer through this
  // same path — addBundle/addToCart both end in refresh(), which runs syncGifts, so the
  // promise doesn't resolve until the free gifts are in the cart.
  (window.VALORA = window.VALORA || {}).cart = {
    addOffer: function (variantId, qty) {
      qty = parseInt(qty || "1", 10);
      return qty >= BUNDLE_QTY ? addBundle(variantId, qty) : addToCart(variantId, qty);
    }
  };

  $$("[data-add-to-cart]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.getAttribute("data-variant-id"), qty = parseInt(btn.getAttribute("data-qty") || "1", 10);
      if (!id || id === "0") { showToast("Connect your product in Theme editor → Offer"); return; }
      btn.disabled = true; btn.style.opacity = ".7";
      var op = qty >= BUNDLE_QTY ? addBundle(id, qty) : addToCart(id, qty);
      op.then(function () {
        btn.disabled = false; btn.style.opacity = "";
        showToast(qty >= BUNDLE_QTY ? "Added — The 90-Day Reset" : "Added to cart");
        openCart();
      }).catch(function () { btn.disabled = false; btn.style.opacity = ""; showToast("Something went wrong — try again"); });
    });
  });

  if (itemsEl) itemsEl.addEventListener("click", function (e) {
    var line = e.target.closest(".cart-line"); if (!line) return;
    var key = line.getAttribute("data-key");
    var span = $(".cart-qty span", line), qty = parseInt(span ? span.textContent : "1", 10);
    if (e.target.closest("[data-inc]")) changeQty(key, qty + 1);
    else if (e.target.closest("[data-dec]")) changeQty(key, Math.max(0, qty - 1));
    else if (e.target.closest("[data-remove]")) changeQty(key, 0);
  });

  if (upsellEl) upsellEl.addEventListener("click", function (e) {
    if (!e.target.closest("[data-upsell]")) return;
    if (nmnId) addBundle(nmnId, BUNDLE_QTY);
  });

  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", function () { refresh(); openCart(); }); });
  $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCart); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
  var checkout = $("[data-checkout]");
  if (checkout) checkout.addEventListener("click", function () { if ((currentCart.item_count || 0) === 0) { showToast("Your cart is empty"); return; } window.location.href = "/checkout"; });

  refresh();
})();
